<ng-template #confirmPopup let-modal>
    <div class="custom-modal" [ngClass]="this.modalSize === 'lg' ? 'large-modal' : ''">
        <div class="modal-content" [ngClass]="this.modalSize === 'lg' ? 'large-modal' : ''">
            <ng-container>
                <div class="block w-100 d-flex flex-column align-items-center justify-content-center py-3 px-2 position-relative">
                    <button *ngIf="showCloseBtn" type="button" (click)="closeModal()" class="btn-close button-cross" [ngClass]="this.modalSize === 'lg' ? 'btn-bg-pre-log' : ''" aria-label="Close"></button>
                    <ng-content></ng-content>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>

<!-- text -->
<!-- <ion-text class="font-20 m-0 weight-700" color="primary">{{ this.popupData[this.popupType].heading }}</ion-text>
<img class="pb-2" [src]="this.popupData[this.popupType].image" alt="img" /> -->

<!-- button -->
<!-- <div class="row w-100 pt-2">
    <div *ngIf="this.popupData[this.popupType].displayButtonOne" class="col">
        <bh-button [theme]="'dark'" (click)="submitFormData(true)">{{ this.popupData[this.popupType].buttonOneText }}</bh-button>
    </div>
    <div *ngIf="this.popupData[this.popupType].displayButtonTwo" class="col">
        <bh-button [theme]="'light'" (click)="closeModal()">{{ this.popupData[this.popupType].buttonTwoText }}</bh-button>
    </div>
</div> -->
